/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { OTPAttestationData } from './OTPAttestationData';
import {
    OTPAttestationDataFromJSON,
    OTPAttestationDataFromJSONTyped,
    OTPAttestationDataToJSON,
} from './OTPAttestationData';

/**
 * 
 * @export
 * @interface OTPAttestation
 */
export interface OTPAttestation {
    /**
     * 
     * @type {string}
     * @memberof OTPAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof OTPAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {OTPAttestationData}
     * @memberof OTPAttestation
     */
    data?: OTPAttestationData;
}

/**
 * Check if a given object implements the OTPAttestation interface.
 */
export function instanceOfOTPAttestation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;

    return isInstance;
}

export function OTPAttestationFromJSON(json: any): OTPAttestation {
    return OTPAttestationFromJSONTyped(json, false);
}

export function OTPAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPAttestation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': !exists(json, 'data') ? undefined : OTPAttestationDataFromJSON(json['data']),
    };
}

export function OTPAttestationToJSON(value?: OTPAttestation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge_id': value.challenge_id,
        'challenge_type': ChallengeTypeToJSON(value.challenge_type),
        'data': OTPAttestationDataToJSON(value.data),
    };
}

